<template>
<div class="text-center">
    <template v-if="order">
        <span class="sr-only"> {{ $t('message.merci') }}</span>
                  <b-row>
            <div class="col-12">
              <div class="timeline-box h-100">
                <div class="box-title">
                  <i class="fa fa-list" aria-hidden="true"></i>
                  {{ $t('message.detailsFacture') }}
                </div>
                <div class="box-content">
                  <div class="box-item column-display-style column-display-style-without-mb">
                    <div class="row">
                      <div class="col-6 text-right">
                        <p><strong>{{ $t('message.nomSouscripteur') }}</strong></p>
                      </div>
                      <div class="col-6 text-left">
                        <p>{{ order.souscripteur.user.nom }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 text-right">
                        <p><strong>{{ $t('message.nomPatient') }}</strong></p>
                      </div>
                      <div class="col-6 text-left">
                        <p>{{ order.patients.user.nom }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 text-right">
                        <p><strong>{{ $t('message.amount') }}</strong></p>
                      </div>
                      <div class="col-6 text-left">
                        <p>{{ order.amount }} FCFA</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 text-right">
                        <p><strong>{{ $t('message.dateFacturation') }}</strong></p>
                      </div>
                      <div class="col-6 text-left">
                        <p>{{ formattedDate(order.date_payment) }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 text-right">
                        <p><strong>{{ $t('message.status') }}</strong></p>
                      </div>
                      <div class="col-6 text-left">
                        <p>{{ getStatut(order.statut) }}</p>
                      </div>
                    </div>
                    <div class="row" v-if="order.statut == 'PAYE'">
                      <div class="col-6 text-right">
                        <p><strong>{{ $tc('message.motifPayment',2) }}</strong></p>
                      </div>
                      <div class="col-6 text-left">
                        <p>{{ order.motif }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="box-footer">
                </div>
              </div>
            </div>
          </b-row>
    </template>
</div>
</template>

<script>
import {mapGetters} from "vuex";
import Swal from 'sweetalert2';
    import moment from 'moment';
export default {
    name: 'PaymentSuccess',
    props: ["baseURL"],
    computed: {
      ...mapGetters(["paymentPrestation"]),

      order:function () {
        // console.log(this.paymentPrestation);
         return this.paymentPrestation;
      }
    },
    data() {
        return {
            updated: false,
            token: null,
            mOrder:{},
            sessionId: null
        }
    },
    methods: {
        saveOrder() {
            Swal.fire(
                "Paiement reussi !",
                "Votre paiement a été effectué avec succés, merci d'avoir choisi médicasure.",
                'success'
            )
        },
        getStatut(item){
          if ( item == 'PAYE'  ) return 'Facture payé';
          else return item;
        },
        formattedDate(date) {
           return moment(date).format('DD-MM-YYYY');
        },
        getPaymentStatut() {
                let args = {
                   id: this.$route.params.id
                };

                this.$store.dispatch('getPaymentPrestationStatus', { args : args });
            },
    },
    mounted() {
        this.saveOrder();
        this.getPaymentStatut();
    }
}
</script>
